import { atom } from "jotai";
import { MessageT } from "src/types/chatTypes";
import { v4 as uuid } from "uuid";

const messageAtom = atom<MessageT>({ message: "" });
const isBotRespondingAtom = atom(false);
const recorderAtom = atom<MediaRecorder | null>(null);
export { messageAtom, isBotRespondingAtom, recorderAtom };
